export default __webpack_public_path__ + "static/media/section-reime-verse.0feea1c5.png";